<template>
    <div class="follow_wrap">
        <div class="time">创建时间：{{ info.createdon }}</div>
        <div class="content">
            <div class="title">跟进阶段</div>
            <div class="box">{{ info.new_followtype }}</div>

            <div class="title">内容记录</div>
            <div class="box">{{ info.new_content }}</div>

            <div class="title">下次跟进日期</div>
            <div class="box">{{ info.new_followdate }}</div>

            <div class="title">附件</div>
            <div class="list">
                <template v-for="(item,index) in info.attach">
                    <img :key="index" :src="item" @click="lookImg(index)" class="item"></img>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {getFollowInfo} from "@/js/archives/dossier";
import {ImagePreview} from "vant";

export default {
    name: "FollowUpDetail",
    data() {
        return {
            info: {}
        }
    },
    created() {
        $init(() => {
            this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
            this.getFollowInfoFun()
        })
    },
    methods: {
        getFollowInfoFun() {
            getFollowInfo({
                new_accountfollowid: this.$route.query.id
            }).then((res) => {
                let info = res.data.data.result;
                info.createdon = info.createdon.split(' ')[0].replaceAll('-', '/');
                this.info = info;
                this.$store.commit("loadSkeleton", {bool: false});
            })
        },
        lookImg(index = 0) {
            ImagePreview({
                images: this.info.attach,
                startPosition: index
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.follow_wrap {
    width: 100%;
    min-height: 100vh;
    background-color: #F9F9FB;
    padding-bottom: env(safe-area-inset-bottom);

    .time {
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
        padding: 48px 0 32px 64px;
    }

    .content {
        box-sizing: border-box;
        width: 718px;
        margin: 0 auto;
        padding: 16px;
        background: #FFFFFF;
        border-radius: 16px 16px 16px 16px;
    }

    .title {
        font-size: 36px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 42px;
        padding-top: 48px;
        padding-left: 32px;
        padding-bottom: 24px;
    }

    .box {
        box-sizing: border-box;
        width: 100%;
        background: #F9F9FB;
        border-radius: 16px 16px 16px 16px;
        padding: 22px 32px;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #0D53FC;
        line-height: 28px;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 28px;

        .item {
            width: 160px;
            height: 160px;
            background: #b7b7b7;
            border-radius: 24px 24px 24px 24px;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }
}
</style>
